const BASE_URL = process.env.REACT_APP_API_BASE_URL; 

const getAuthHeaders = () => {
    const token = sessionStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
};

// Function for Calling Submit API
export const submitTemplate = async (payload) => {
    const headers = getAuthHeaders(); 

    try {
        const response = await fetch(`${BASE_URL}/customer/submit-pricing-table`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });

        return await response.json();
    } catch (error) {
        //console.error(error);
        throw error;
    }
};

//Function for Call Get Template List Api 
export const getTemplateList = async () => {
    const headers = getAuthHeaders(); 
    try {
        const response = await fetch(`${BASE_URL}/customer/pricing-table-template-list`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Something went wrong');
        }

        return data; 
    } catch (error) {
        throw error;
    }
};


//Function for Calling Update Template Name
export const updateTemplateName = async (payload) => {
    const headers = getAuthHeaders(); 

    try {
        const response = await fetch(`${BASE_URL}/customer/update-pricing-table-template-name`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });

        return await response.json();
    } catch (error) {
        //console.error(error);
        throw error;
    }
};



//Function for Calling Delete Template
export const deleteTemplateData = async (payload) => {
    const headers = getAuthHeaders(); 

    try {
        const response = await fetch(`${BASE_URL}/customer/delete-pricing-table-template`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });

        return await response.json();
    } catch (error) {
        //console.error(error);
        throw error;
    }
};

// Function for Calling Get Template Detail API
export const getTemplateDetail = async (id) => {
    const headers = getAuthHeaders(); 

    try {
        const response = await fetch(`${BASE_URL}/customer/pricing-table-template-detail?template_id=${id}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                ...headers,
            }
        });

        return await response.json();
    } catch (error) {
        //console.error(error);
        throw error;
    }
};

//Function for Calling Update Template API
export const updateTemplateDetail = async (payload) => {
    const headers = getAuthHeaders(); 

    try {
        const response = await fetch(`${BASE_URL}/customer/update-pricing-table-template-detail`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });

        return await response.json();
    } catch (error) {
        //console.error(error);
        throw error;
    }
};